<template>
    <div class="field">
        <label for="icon">Icon</label>
        <Dropdown v-model="selectedIcon" optionValue="value" :options="getAttributeIcons()" @change="emit('update:modelValue', selectedIcon)" placeholder="Select an icon" showClear>
            <template #value="slotProps">
                <div v-if="slotProps.value">
                    <span class="icon">
                        <i :class="'pi ' + slotProps.value"></i>
                    </span>
                </div>
                <div v-else>
                    {{ slotProps.placeholder }}
                </div>
            </template>
            <template #option="slotProps">
                <div class="flex align-items-center">
                    <span class="mr-2 icon">
                        <i :class="'pi ' + slotProps.option.value"></i>
                    </span>
                    <div>{{ slotProps.option.name }}</div>
                </div>
            </template>
        </Dropdown>
    </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { getAttributeIcons } from '../constants';

const emit = defineEmits(['update:modelValue']);
const selectedIcon = ref(null);
</script>
